import { GraphQLClient } from "graphql-request";

import { env } from "../../utils/libs/env";

import type { RequestConfig } from "graphql-request/build/esm/types";

export const FederationClient = (config: RequestConfig) => {
  return new GraphQLClient(env.NEXT_PUBLIC_FEDERATION_URL, {
    credentials: "omit",
    ...config,
  });
};
